import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  DamageCostEvaluationAggregateDto,
  DamageCostEvaluationAggregateReferenceDto,
  DamageCostEvaluationItemDto,
  DamageCostEvaluationItemReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import DamageCostEvaluationAggregateInline, {
  DamageCostEvaluationAggregateInlineProps,
} from "./DamageCostEvaluationAggregateInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity:
    | DamageCostEvaluationAggregateDto
    | DamageCostEvaluationAggregateReferenceDto
    | null
    | undefined;
  entityId?: string | null;
  item?: DamageCostEvaluationItemDto | DamageCostEvaluationItemReferenceDto;
  itemId?: string | null;
  inlineProps?: Partial<DamageCostEvaluationAggregateInlineProps>;
}

export default function DamageCostEvaluationAggregateLink({
  entity,
  entityId,
  item,
  itemId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.DamageCostEvaluationRead]}
      to={ROUTE_PATH.DAMAGE_COST_EVALUATION_AGGREGATE_VIEW(entity?.id || entityId || "")}
      content={
        <DamageCostEvaluationAggregateInline
          entity={entity}
          entityId={entityId}
          item={item}
          itemId={itemId}
          {...inlineProps}
        />
      }
      {...otherProps}
    />
  );
}
